import { render, staticRenderFns } from "./DailyCauselist.vue?vue&type=template&id=1b10a38c&scoped=true"
import script from "./DailyCauselist.vue?vue&type=script&lang=js"
export * from "./DailyCauselist.vue?vue&type=script&lang=js"
import style0 from "./DailyCauselist.vue?vue&type=style&index=0&id=1b10a38c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b10a38c",
  null
  
)

export default component.exports